import React, { useState } from 'react';
import { Link } from 'react-router-dom'; // React Router için
import './Navbar.css';
import logo from '../assets/logo2.png';

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen(prev => !prev);
  };

  const closeMenu = () => {
    setMenuOpen(false);
  };

  return (
    <nav className="navbar">
      <div className="navbar-logo">
        <Link to="/" onClick={closeMenu}>
          <img src={logo} alt="Dijikopi Logo" />
        </Link>
      </div>

      <div className="menu-toggle" onClick={toggleMenu}>
        ☰
      </div>

      <ul className={`navbar-links ${menuOpen ? 'active' : ''}`}>
        <li>
          <Link to="/hakkimizda" onClick={closeMenu}>
            Hakkımızda
          </Link>
        </li>
        <li>
          <Link to="/hizmetler" onClick={closeMenu}>
            Hizmetler
          </Link>
        </li>
        <li>
          <Link to="/konum" onClick={closeMenu}>
            Konum
          </Link>
        </li>
        <li>
          <Link to="/iletisim" onClick={closeMenu}>
            İletişim
          </Link>
        </li>
      </ul>
    </nav>
  );
};

export default Navbar;
